
import { defaultSettings as allDefaultSettings, initialSections as allInitialSections } from "@/utils/pdf-templates/constants";
import { TemplateStyle as TStyle, Column } from "@/utils/pdf-templates/types";

export const templates = [
  { id: 'template1', name: 'تصميم عصري' },
  { id: 'template2', name: 'تصميم احترافي' },
  { id: 'template3', name: 'تصميم أنيق' },
  { id: 'template4', name: 'إبداع رقمي' },
  { id: 'template5', name: 'فخامة كلاسيكية' },
  { id: 'template6', name: 'تقنية متقدمة' },
  { id: 'template7', name: 'رحلة ذهبية' },
];

export const initialSections = allInitialSections;
export const defaultSettings = allDefaultSettings;

export type TemplateStyle = TStyle;

export interface AllTemplateSettings {
  [templateId: string]: TemplateStyle;
}
